import React from 'react';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Send, Mail, Sparkles, Loader2 } from 'lucide-react';
import { API } from '../lib/api';
import { toast } from '../hooks/use-toast';

export const DigestSendButton = () => {
  const [open, setOpen] = React.useState(false);
  const [busy, setBusy] = React.useState(false);
  const [preview, setPreview] = React.useState(null);
  const [lastDelivery, setLastDelivery] = React.useState(null);

  const openDialog = async () => {
    setOpen(true); setBusy(true); setLastDelivery(null);
    try {
      const r = await fetch(`${API}/alerts/digest/preview`, { credentials: 'include' });
      const j = await r.json();
      if (!r.ok) throw new Error(j.detail || 'Preview failed');
      setPreview(j);
    } catch (err) {
      toast({ title: 'Preview failed', description: err.message });
      setOpen(false);
    } finally { setBusy(false); }
  };

  const sendNow = async () => {
    setBusy(true);
    try {
      const r = await fetch(`${API}/alerts/digest/send-now`, { method: 'POST', credentials: 'include' });
      const j = await r.json();
      if (!r.ok) throw new Error(j.detail || 'Send failed');
      setLastDelivery(j.delivery);
      toast({ title: 'Digest sent', description: `Provider: ${j.delivery?.provider || 'console'} · ${j.alerts_count} alerts` });
    } catch (err) {
      toast({ title: 'Send failed', description: err.message });
    } finally { setBusy(false); }
  };

  return (
    <>
      <Button onClick={openDialog} variant="outline" className="border-brand-border text-brand-indigo">
        <Mail className="h-4 w-4 mr-2" /> Weekly Digest
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-3xl max-h-[85vh] overflow-hidden flex flex-col">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2"><Sparkles className="h-4 w-4 text-brand-green" /> RM Coaching Digest — Preview</DialogTitle>
          </DialogHeader>
          <div className="flex-1 overflow-y-auto -mx-6 px-6">
            {busy && !preview ? (
              <div className="flex items-center justify-center py-12 text-muted-foreground"><Loader2 className="h-4 w-4 animate-spin mr-2" /> Preparing preview…</div>
            ) : preview ? (
              <>
                <div className="mb-3 text-xs text-muted-foreground">
                  Subject: <span className="font-semibold text-brand-indigo">{preview.subject}</span> · {preview.alerts_count} alert{preview.alerts_count !== 1 && 's'}
                </div>
                <iframe title="Digest preview" srcDoc={preview.html} className="w-full min-h-[400px] rounded-md border border-brand-border" />
                {lastDelivery && (
                  <div className="mt-3 text-[11px] rounded-md border border-brand-border bg-brand-bg px-3 py-2">
                    <div><span className="font-semibold text-brand-indigo">Delivery:</span> {lastDelivery.provider}</div>
                    <div><span className="font-semibold text-brand-indigo">Status:</span> {lastDelivery.status}</div>
                    {lastDelivery.file && <div className="break-all"><span className="font-semibold text-brand-indigo">Saved copy:</span> {lastDelivery.file}</div>}
                    {lastDelivery.reason && <div className="text-brand-amber">Note: {lastDelivery.reason}</div>}
                  </div>
                )}
              </>
            ) : null}
          </div>
          <DialogFooter>
            <div className="flex-1 text-[11px] text-muted-foreground text-left">Delivery is <strong>MOCKED to console + on-disk file</strong> until an email provider key is configured.</div>
            <Button variant="outline" onClick={() => setOpen(false)}>Close</Button>
            <Button onClick={sendNow} disabled={busy} className="bg-brand-indigo hover:bg-brand-indigoLight text-white">
              <Send className="h-3.5 w-3.5 mr-2" /> {busy ? 'Sending\u2026' : 'Send now'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DigestSendButton;
